import React from "react";

/**
 * Card component - rounded-lg, subtle border/shadow.
 * Follows UI guidelines for professional styling.
 * @see .cursor/ui.md
 */
const Card = ({
  children,
  className = "",
  padding = "default", // none | sm | default | lg
  variant = "default", // default | bordered | elevated
  ...props
}) => {
  const paddingClasses = {
    none: "",
    sm: "p-4",
    default: "p-6",
    lg: "p-8",
  };

  const variantClasses = {
    default: "bg-white shadow-sm",
    bordered: "bg-white shadow-sm",
    elevated: "bg-white shadow-md",
  };

  const cardClasses = [
    "rounded-xl overflow-hidden",
    variantClasses[variant],
    paddingClasses[padding],
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={cardClasses} {...props}>
      {children}
    </div>
  );
};

/**
 * Card header with optional title and actions
 */
export const CardHeader = ({
  title,
  subtitle,
  actions,
  className = "",
}) => (
  <div className={`flex items-start justify-between gap-4 mb-4 ${className}`}>
    <div>
      {title && (
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
      )}
      {subtitle && (
        <p className="mt-1 text-sm text-gray-500">{subtitle}</p>
      )}
    </div>
    {actions && <div className="shrink-0">{actions}</div>}
  </div>
);

export default Card;
